import React from "react";
import i18n from "../../../../utils/ChrI18n";
import * as ArrayExtensions from "../../../../utils/CoreExtensions/ArrayExtensions";
import ReportMetricForAlert from "./ReportMetricForAlert";
import { useListSearch } from "../../../../hooks/generic/Form/useListSearch";


const ReportMetricsListingForAlert = (props) => {
  const { metrics, tabsInfo, groupMetricsByTab = false } = props;

  let [ListSearchComponent, shortlistedMetrics] = useListSearch({
    list: metrics,
    searchable: metrics.length > 0,
    listItemValueMapper: metric => metric.title,
    formControlClass: "b-r-sm",
    formGroupClass: "mb-2",
  });

  const metricsGroupedByTab = ArrayExtensions.groupBy(shortlistedMetrics, "tab");
  const getMetricsForTab = tab => {
    const tabMetrics = metricsGroupedByTab[tab];
    return (
      <div key={tab} className="pb-3">
        <div className="d-flex">
          <span className="font-600 p-2 font-16">{tabsInfo[tab].title}</span>
        </div>
        <div className='cui-management-report-temp-metric-submetric-link'>
          {tabMetrics.map(metric => <ReportMetricForAlert key={metric.uId} metric={metric} onActionTrigger={props.onActionTrigger} />)}
        </div>
      </div>
    );
  };

  const isEmptyResult = ArrayExtensions.isEmpty(shortlistedMetrics);

  const getMetrics = () => {
    if(groupMetricsByTab) {
      return Object.keys(tabsInfo).map(tab => {
        if (ArrayExtensions.isEmpty(metricsGroupedByTab[tab])) return;
        return getMetricsForTab(tab);
      })
    }
    else {
      return shortlistedMetrics.map(metric => <ReportMetricForAlert key={metric.uId} metric={metric} onActionTrigger={props.onActionTrigger} />)
    }
  }

  return (
    <div className="d-flex flex-column flex-gap-5">
      { ListSearchComponent }
      <div className={`cui-management-report-temp-metric-submetric-link`}>
        { isEmptyResult && <span className="text-muted px-2">{i18n.t("metrics.no_metrics_to_show")}</span> }
        { !isEmptyResult && getMetrics() }
      </div>
    </div>
  );
};

export default ReportMetricsListingForAlert;
